import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { brandDealsQuery } from '@/services/brand-deals';
import { myRoleQuery } from '@/services/team-members';
import { ArenaPage } from '@/features/arena/arena-page';
import { DealsForSeat } from '@/features/operations/operator/deals-for-seat';
import { parseDealsSearch, type DealsSearchInput } from '@/features/operations/deals-search';

// Operations' Deals view (formerly the Brand Deal Arena, `/brand-deals`): every deal, start to finish.
export const Route = createFileRoute('/_authed/operations/deals')({
  validateSearch: (search: DealsSearchInput & SearchSchemaInput) => parseDealsSearch(search),
  // Her role decides the view and its money; an API without roles answers 404 (nothing narrows). A role without Deals
  // never reads them: the page shows the role card instead.
  loader: async ({ context: { queryClient, team } }) => {
    if (!team) return;
    const mine = await queryClient.ensureQueryData(myRoleQuery(team.id)).catch(() => null);
    if (mine && !mine.role.pages['brand-deals']) return;
    await queryClient.ensureQueryData(brandDealsQuery(team.id));
  },
  component: DealsRoute,
});

function DealsRoute() {
  // An operator reads it in his words (whose move each waiting thing is); everyone else exactly as it was.
  return (
    <DealsForSeat>
      <ArenaPage search={Route.useSearch()} />
    </DealsForSeat>
  );
}
